<form class="page-container gap-24" [formGroup]="newsBannerForm">
  <div class="page-title justify-space-between">
    <span class="font-bold-display-medium">
      Banner {{ editMode ? 'bearbeiten' : 'hinzufügen' }}
    </span>
    <div class="flex-r gap-16 header-buttons">
      <button
        type="button"
        [disabled]="isLoading"
        class="inwi-text-button-medium-secondary"
        (click)="onCancel()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-xmark"></i>
          </div>
          <div class="button-text">Abbrechen</div>
        </div>
      </button>
      <button
        type="submit"
        [disabled]="isLoading"
        class="inwi-text-button-medium-primary"
        (click)="onSubmit()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-floppy-disk"></i>
          </div>
          <div class="button-text">Speichern</div>
        </div>
      </button>
    </div>
  </div>

  @if (selectedImage && !isLoading) {
    <div
      class="image flex-c"
      [style]="
        selectedImage
          ? { 'background-image': 'url(' + selectedImage + ')' }
          : {}
      ">
      <div class="image-text">
        <div class="image-title" [title]="newsBannerForm.get('title')?.value">
          {{ newsBannerForm.get('title')?.value }}
        </div>
        <div
          class="image-details"
          [innerHtml]="newsBannerForm.get('teaserText')?.value"></div>
      </div>
    </div>
  }

  @if (selectedCategory && !isLoading) {
    <app-hero-card-placeholder
      class="hero-card-placeholder"
      [colorHead]="selectedCategory.color0"
      [colorShapes]="selectedCategory.color70"
      [backgroundColor]="selectedCategory.color80">
      <div class="image-text">
        <div class="image-title" [title]="newsBannerForm.get('title')?.value">
          {{ newsBannerForm.get('title')?.value }}
        </div>
        <div
          class="image-details"
          [innerHtml]="newsBannerForm.get('teaserText')?.value"></div>
      </div>
    </app-hero-card-placeholder>
  }

  @if (showPlaceholderCard) {
    <!-- CardPlaceholder -->
    <app-hero-card-placeholder
      class="hero-card-placeholder"
      [colorHead]="placeholderSlide.color0"
      [colorShapes]="placeholderSlide.color70"
      [backgroundColor]="placeholderSlide.color80">
      <div class="image-text">
        <div class="image-title" [style.color]="placeholderSlide.color0">
          {{ placeholderSlide.title }}
        </div>
        <div
          class="image-details"
          [innerHTML]="placeholderSlide.description"></div>
      </div>
    </app-hero-card-placeholder>
  }

  @if (isLoading) {
    <!-- Image Skeleton -->
    <p-skeleton
      borderRadius="12px"
      width="100%"
      height="100%"
      class="image-skeleton"></p-skeleton>
  }

  <!-- Formular -->
  <div class="page-title justify-space-between">
    <span class="title-content">
      <i class="fa-regular fa-pen font-medium-display-small"></i>
      <span class="font-medium-display-small"> Inhalt </span>
    </span>
    @if (editMode) {
      <button
        type="button"
        [disabled]="isLoading"
        class="inwi-text-button-medium-outline"
        (click)="onDeleteNewsBanner()">
        <div class="button-content">
          <div class="button-icon">
            <i class="fa-regular fa-trash-can"></i>
          </div>
          <div class="button-text">Banner Löschen</div>
        </div>
      </button>
    }
  </div>

  <div class="formular">
    <!-- Left side -->
    <div class="flex-c gap-16 flex-2-0-0 align-self-stretch">
      <!-- Title -->
      <div class="form-row">
        <div class="input-simple align-self-stretch">
          <div class="input-label-wrapper">
            <label for="title" class="input-label">
              Titel des Banners{{
                fieldRequired(newsBannerForm.get('title')) ? '*' : ''
              }}
            </label>
            <div class="input-label-hint">
              {{ getTextAreaLength(newsBannerForm.get('title')) }}
              /
              {{ getMaxLengthFromValidator(newsBannerForm.get('title')) }}
            </div>
          </div>
          @if (isLoading) {
            <p-skeleton width="100%" height="56px"></p-skeleton>
          } @else {
            <textarea
              id="title"
              name="title"
              class="input-textarea"
              rows="1"
              placeholder="Titel"
              formControlName="title"></textarea>
          }
          <app-error-message
            [formField]="newsBannerForm.get('title')"></app-error-message>
        </div>
      </div>

      <!-- Subtitle -->
      <div class="form-row">
        <div class="input-simple align-self-stretch">
          <div class="input-label-wrapper">
            <label for="subtitle" class="input-label">
              Subtitel{{
                fieldRequired(newsBannerForm.get('subtitle')) ? '*' : ''
              }}
            </label>
            <div class="input-label-hint">
              {{ getTextAreaLength(newsBannerForm.get('subtitle')) }}
              /
              {{ getMaxLengthFromValidator(newsBannerForm.get('subtitle')) }}
            </div>
          </div>
          @if (isLoading) {
            <p-skeleton width="100%" height="56px"></p-skeleton>
          } @else {
            <textarea
              id="subtitle"
              name="subtitle"
              class="input-textarea"
              rows="1"
              placeholder="Subtitel"
              formControlName="subtitle"></textarea>
          }
          <app-error-message
            [formField]="newsBannerForm.get('subtitle')"></app-error-message>
        </div>
      </div>

      <!-- Description -->
      <div class="form-row">
        <div class="flex-c align-start gap-16 align-self-stretch">
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="description" class="input-label">
                Beschreibung{{
                  fieldRequired(newsBannerForm.get('description')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(newsBannerForm.get('description')) }}
                /
                {{
                  getMaxLengthFromValidator(newsBannerForm.get('description'))
                }}
              </div>
            </div>
            @if (isLoading) {
              <p-skeleton width="100%" height="128px"></p-skeleton>
            } @else {
              <textarea
                id="description"
                name="description"
                class="input-textarea"
                rows="4"
                placeholder="Beschreibung"
                formControlName="description"></textarea>
            }
            <app-error-message
              [formField]="
                newsBannerForm.get('description')
              "></app-error-message>
          </div>
        </div>
      </div>

      <!-- Teaser Text -->
      <div class="form-row">
        <div class="flex-c align-start gap-16 align-self-stretch">
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="teaserText" class="input-label">
                Teaser Text{{
                  fieldRequired(newsBannerForm.get('teaserText')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(newsBannerForm.get('teaserText')) }}
                /
                {{
                  getMaxLengthFromValidator(newsBannerForm.get('teaserText'))
                }}
              </div>
            </div>
            @if (isLoading) {
              <p-skeleton width="100%" height="56px"></p-skeleton>
            } @else {
              <textarea
                id="teaserText"
                name="teaserText"
                class="input-textarea"
                rows="1"
                placeholder="Teaser Text"
                formControlName="teaserText"></textarea>
            }
            <app-error-message
              [formField]="
                newsBannerForm.get('teaserText')
              "></app-error-message>
          </div>
        </div>
      </div>

      <!-- Link -->
      <div class="form-row">
        <div class="flex-c align-start gap-16 align-self-stretch">
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="link" class="input-label">
                Link{{ fieldRequired(newsBannerForm.get('link')) ? '*' : '' }}
              </label>
            </div>
            @if (isLoading) {
              <p-skeleton width="100%" height="56px"></p-skeleton>
            } @else {
              <input
                id="link"
                name="link"
                class="input-text"
                type="text"
                placeholder="Link"
                formControlName="link" />
            }

            <app-error-message
              [formField]="newsBannerForm.get('link')"></app-error-message>
          </div>
        </div>
      </div>

      <!-- Link Text -->
      <div class="form-row">
        <div class="flex-c align-start gap-16 align-self-stretch">
          <div class="input-simple align-self-stretch">
            <div class="input-label-wrapper">
              <label for="linkText" class="input-label">
                Link Text{{
                  fieldRequired(newsBannerForm.get('linkText')) ? '*' : ''
                }}
              </label>
              <div class="input-label-hint">
                {{ getTextAreaLength(newsBannerForm.get('linkText')) }}
                /
                {{ getMaxLengthFromValidator(newsBannerForm.get('linkText')) }}
              </div>
            </div>
            @if (isLoading) {
              <p-skeleton width="100%" height="56px"></p-skeleton>
            } @else {
              <input
                id="linkText"
                name="linkText"
                class="input-text"
                type="text"
                placeholder="Link Text"
                formControlName="linkText" />
            }
            <app-error-message
              [formField]="newsBannerForm.get('linkText')"></app-error-message>
          </div>
        </div>
      </div>
    </div>

    <!-- Right side -->
    <div class="flex-c gap-16 align-self-stretch">
      <!-- Content type -->
      <div class="form-row">
        <div class="input-simple flex-1-1-0">
          <label for="contentType" class="input-label">
            Inhalt auswählen{{
              fieldRequired(newsBannerForm.get('contentType')) ? '*' : ''
            }}
          </label>
          @if (isLoading) {
            <p-skeleton width="100%" height="56px"></p-skeleton>
          } @else {
            <p-select
              id="contentType"
              formControlName="contentType"
              [options]="contentTypeOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Inhalt auswählen..." />
          }
          <app-error-message
            [formField]="newsBannerForm.get('contentType')"></app-error-message>
        </div>
        <div class="input-simple flex-1-1-0"></div>
      </div>

      @if (showCategoryDropdown) {
        <div class="form-row">
          <div class="input-simple flex-1-1-0">
            <label for="categoryId" class="input-label">
              Kategorie auswählen{{
                fieldRequired(newsBannerForm.get('categoryId')) ? '*' : ''
              }}
            </label>
            @if (isLoading) {
              <p-skeleton width="100%" height="56px"></p-skeleton>
            } @else {
              <p-select
                id="categoryId"
                formControlName="categoryId"
                [options]="categoryOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Kategorie auswählen..." />
            }
            <app-error-message
              [formField]="
                newsBannerForm.get('categoryId')
              "></app-error-message>
          </div>
          <div class="input-simple flex-1-1-0"></div>
        </div>
      }

      <!-- Content -->
      @if (showImageUpload) {
        <input
          type="file"
          #fileInput
          accept="image/*"
          (change)="onFileSelected($event)"
          style="display: none" />
        <div class="flex-c gap-16">
          @if (isLoading) {
            <p-skeleton width="288px" height="200px"></p-skeleton>
          } @else {
            <div
              class="image-upload-container"
              [style.background-image]="
                selectedImage ? 'url(' + selectedImage + ')' : ''
              "
              [style.background-size]="'cover'"
              [style.background-position]="'center'"
              [class.dashed-border-error]="
                newsBannerForm.get('image').invalid &&
                newsBannerForm.get('image').touched
              "
              (click)="handleImageUpload()">
              <button class="circle-medium border-none">
                <div class="circle-icon">
                  <i class="fa-regular fa-plus"></i>
                </div>
              </button>
            </div>
          }
          <app-error-message
            [formField]="newsBannerForm.get('image')"></app-error-message>
        </div>
      }

      @if (showCategoryCard) {
        <app-news-banner-category-card
          [backgroundColor]="selectedCategory?.color80"
          [colorHead]="selectedCategory?.color0"
          [colorShapes]="
            selectedCategory?.color0
          "></app-news-banner-category-card>
      }
    </div>
  </div>
</form>
